<template>
  <div class="wrap">
    <button
        class="share hover_op"
        @click="show_share_modal = !show_share_modal"
    >
      Share
      <img src="@/assets/img/share_room_link.svg" alt=""/>
    </button>

    <div
        class="share_drop drop"
        :class="{ active: show_share_modal }"
    >
      <p class="title">Share</p>

      <p class="mail_title">Email address</p>

      <div class="mail_adress_wrap">
        <input type="text" v-model="share_mail" @keyup.enter="addMail"/>
        <button class="add" @click="addMail">Add</button>
      </div>

      <div
          class="added_mail"
          v-for="(viewer, viewIndex) in added_mails"
          v-bind:key="viewer.id"
      >
        {{ viewer }}

        <button class="remove hover_op" @click="removeEmail(viewIndex)">
          <img src="@/assets/img/mob_close_menu_icon.svg" alt=""/>
        </button>
      </div>

      <div
          class="added_mail"
          v-for="viewer in sharedEmails"
          v-bind:key="viewer.id"
      >
        {{ viewer.emailAddress }}

        <button class="remove hover_op" @click="denyAccess(viewer.id)">
          <img src="@/assets/img/mob_close_menu_icon.svg" alt=""/>
        </button>
      </div>

      <button
          v-if="added_mails.length"
          class="color_btn hover_op"
          @click="shareMails"
      >
        <span v-if="!shared">Share ({{ added_mails.length }})</span>

        <span v-if="shared">
          Shared
          <img src="@/assets/img/checked_white_icon.svg" alt=""/>
        </span>
      </button>

      <div class="public_switcher">
        Public
        <div
            class="public_switch"
            :class="{ active: isPublic }"
            @click="makePublic(!isPublic)"
        >
          <div class="pin"></div>
        </div>
      </div>

      <p class="public_info" v-if="isPublic">
        Anyone with the link can view
      </p>

      <button
          v-if="isPublic"
          class="color_btn hover_op"
          @click="link_copied = true"
          v-clipboard:copy="share_link"
          v-clipboard:error="onError"
      >
        <span v-if="!link_copied">Copy Link</span>

        <span v-if="link_copied">
          Link copied
          <img src="@/assets/img/checked_white_icon.svg" alt=""/>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from "axios";

export default {
  data() {
    return {
      show_share_modal: false,
      share_mail: "",
      shared: false,
      link_copied: false,
      added_mails: [],
      access: null//TODO: Set access on mounted
    };
  },
  computed: {
    isPublic() {
      return this.access.isPublic
    },
    sharedEmails() {
      return this.access.sharedWith
    },
  },
  props: {
    share_link: String,
    roomId: String,
    transcript: Object
  },
  created() {
    this.access = this.transcript.access
  },
  methods: {
    addMail() {
      const email = this.share_mail.trim().toLowerCase()
      if (email !== "" && !this.sharedEmails.find(it => it.emailAddress.toLowerCase() === email) && !this.added_mails.includes(email)) {
        this.added_mails.push(email);
      }
      this.share_mail = "";
    },

    async shareMails() {
      try {
        this.access = await this.$store.dispatch("shareMeetingTranscriptWithUsers", {
          id: this.transcript.id,
          emailAddresses: this.added_mails
        })
        this.shared = true;
        this.added_mails = [];
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    async makePublic(isPublic) {
      try {
        this.access = await this.$store.dispatch("setMeetingTranscriptPublic", {
          id: this.transcript.id,
          isPublic
        })
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    removeEmail(index) {
      const _addedMails = [...this.added_mails]
      _addedMails.splice(index, 1)
      this.added_mails = _addedMails
    },

    async denyAccess(id) {
      try {
        this.access = await this.$store.dispatch("denyMeetingTranscriptAccess", {
          id: this.transcript.id,
          viewerId: id
        })
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  align-self: center;
  display: flex;
  align-items: center;
}

.share {
  display: flex;
  align-items: center;

  img {
    height: 22px;
    margin-left: 16px;
  }
}

.share_drop {
  width: 422px;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1;
  padding: 32px;

  @media all and (max-width: 767px) {
    padding: 16px;
  }

  .title {
    margin-bottom: 32px;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  .added_mail {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin-top: 32px;
    margin-bottom: 32px;

    .remove {
      width: 32px;
      height: 32px;
      padding: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
      }
    }
  }

  .public_info {
    margin-top: 16px;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 32px;
  }

  .public_switcher {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  .public_switch {
    width: 42px;
    height: 24px;
    border-radius: 8px;
    background-color: #ffe4d9;
    transition: background-color 180ms;
    cursor: pointer;

    .pin {
      top: 6px;
      left: 6px;
      position: absolute;
      width: 12px;
      height: 12px;
      border-radius: 6px;
      background-color: #fc5a12;
      transition: background-color 180ms, left 180ms;
    }

    &.active {
      background-color: #fc5a12;
      transition: background-color 180ms;

      .pin {
        left: 24px;
        background-color: #fff;
        transition: background-color 180ms, left 180ms;
      }
    }
  }

  .mail_title {
    margin-bottom: 8px;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .mail_adress_wrap {
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    border-bottom: 1px solid #d6d6d6;
    margin-bottom: 32px;

    input {
      flex: 1 1 auto;
    }

    .add {
      width: auto;
      height: auto;
      flex: none;
      color: #fc5a12;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      padding: 0;
      opacity: 1;
      transition: opacity 180ms;

      &:hover {
        background-color: transparent;
        opacity: 0.64;
        transition: opacity 180ms;
      }
    }
  }

  .color_btn {
    margin-top: 32px;

    span {
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        margin-left: 16px;
        width: 22px;
      }
    }
  }
}
</style>
